// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".two-dimensional-image .annotation-item{cursor:pointer;min-width:380px;margin-bottom:5px;border-width:2px;border-left-width:8px}.two-dimensional-image .annotation-item--highlight{cursor:default}.two-dimensional-image .annotation-item__object-item-title{min-width:80px}.two-dimensional-image .annotation-item__delete-button{padding:0.375rem 0.3rem;color:#dc3545;font-size:30px}.two-dimensional-image .annotation-item__delete-button:hover{color:#c82333}\n", ""]);
// Exports
module.exports = exports;
